import TApplicationInviteUser from './index.vue';

TApplicationInviteUser.install = app => {
  app.component(TApplicationInviteUser.name, TApplicationInviteUser);
};

export default TApplicationInviteUser;
